import React from 'react';
import { connect } from 'react-redux';
import { axios, Globals } from '../../utils';
import AssistantImg from '../../assets/img/assistant.png';
import AssistantMiniImg from '../../assets/img/assistant-mini.png';
import CloseIcon from '../../assets/icons/close-black.png';
import SentIcon from '../../assets/icons/sent.png';

const KEEP_SCALE_ROUTES = ['dashboard', 'profile-business'];

class BotpressChat extends React.Component {

  messagesEnd = null;
  textareaRef = null;

  state = {
    show_chat: false,
    messages: [{
      text: 'Hola, estoy para asistirte, indícame en qué te puedo ayudar',
    }],
    form: {
      message: ''
    },
    textareaHeight: 24,
    user_key: '',
    conversation_id: '',
    url: '',
    user_id: '',
    remain_uses: 0,
    unlimited: false,
    plan_user: null,
    keepScale: false,
  }

  componentDidMount() {
    this.checkRoute();
    this.load();
  }

  load = async () => {
    if (!this.props.session) {
      try {
        const res = await axios.post('chat-bot/create-session');

        if (res.data?.session) {
          await this.props.dispatch({
            type: 'SET_BOTPRESS_SESSION',
            payload: res.data?.session
          });
        }

      } catch (error) {
        Globals.showError('Ocurrió un error inesperado');
      }
    }
    else {
      this.loadHistory();
    }
  }

  loadHistory = async () => {
    const res = await axios.post('chat-bot/history-session', {
      session: this.props.session
    });

    let messages = [...this.state.messages];
    for (let i = 0; i < res.data?.consultations?.length; i++) {
      messages.push({
        text: res.data.consultations[i].question,
        _self: true
      });
      messages.push({
        text: res.data.consultations[i].response
      });
    }
    this.setState({
      messages
    }, () => this.scrollToBottom());
  }

  checkRoute = () => {
    if (KEEP_SCALE_ROUTES.includes(window.location.hash.substring(2)))
      this.setState({ keepScale: true });
  }

  scrollToBottom = () => {
    this.messagesEnd.scrollTo({
      behavior: 'smooth',
      top: this.messagesEnd.scrollHeight
    });
  }

  change = (e) => {
    this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: e.target.value
      }
    });

    this.autoGrow();
  }

  autoGrow = (e) => {
    this.textareaRef.style.height = "inherit";
    this.textareaRef.style.height = `${Math.max(
      this.textareaRef.scrollHeight,
      24
    )}px`;
  }

  send = async () => {
    if (this.state.form.message) {
      const message = this.state.form.message;

      this.setState({
        form: {
          ...this.state.form,
          message: ''
        }
      });

      let messages = [...this.state.messages];
      messages.push({
        text: message,
        _self: true
      });
      this.setState({
        messages
      }, () => this.scrollToBottom());

      const res = await axios.post('chat-bot/consultation', {
        question: message,
        session: this.props.session
      });

      if (res.data?.response) {
        let messages = [...this.state.messages];
        messages.push({
          text: res.data?.response
        });
        this.setState({
          messages
        }, () => this.scrollToBottom());
      }
    }
  }

  toggleChat = () => {
    this.setState({ show_chat: !this.state.show_chat });
  }

  render() {
    const { messages, show_chat } = this.state;

    return (
      <div id="client-botpress-chat">
        <div className="chat" data-show={show_chat ? 'true' : 'false'}>
          <div className="chat-header">
            <img src={AssistantMiniImg} className="contact-img" alt="Botpress" />
            <p className="contact-name">Braxo: Asistente</p>
            <img src={CloseIcon} className="close-chat" alt="Cerrar chat" onClick={this.toggleChat} />
          </div>
          <div className="container-messages" ref={(el) => { this.messagesEnd = el; }}>
            {
              messages.map((item) => {
                return (
                  <div className={`item-message ${item?._self ? 'self' : ''}`}>
                    <p className="message">{item?.text}</p>
                  </div>
                )
              })
            }
          </div>
          <div>
            <label className="container-textarea">
              <textarea
                className="form-control"
                ref={ref => this.textareaRef = ref}
                rows={1}
                value={this.state.form.message}
                placeholder="Escribe tu consulta"
                name="message"
                onKeyDown={(e) => {
                  if (e.nativeEvent.keyCode == 13) {
                    e.preventDefault();
                    this.send();
                  }
                }}
                onChange={this.change} />
              <button className="btn" onClick={() => this.send()}>
                <img src={SentIcon} className="send-icon" alt="Enviar" />
              </button>
            </label>
          </div>
        </div>
        {!show_chat && (
          <div
            className="chat-btn"
            data-keep-scale={String(this.state.keepScale)}
            onClick={this.toggleChat}
          >
            <style>{`
              body:has(.discounts-table-container) #client-botpress-chat .botpress-img,
              body:has(.commissions-table-container) #client-botpress-chat .botpress-img,
              body:has(.personalizadas-table-container) #client-botpress-chat .botpress-img {
                display: none !important;
              }
              body:has(.discounts-table-container) #client-botpress-chat .chat-btn p,
              body:has(.commissions-table-container) #client-botpress-chat .chat-btn p,
              body:has(.personalizadas-table-container) #client-botpress-chat .chat-btn p {
                background: #1e3a5f;
                color: white;
                padding: 10px 15px;
                border-radius: 20px;
                margin: 0;
                box-shadow: 0 2px 10px rgba(0,0,0,0.2);
              }
            `}</style>
            <img src={AssistantImg} className="botpress-img" alt="Botpress" />
            <p>¿Necesitas ayuda?</p>
          </div>
        )}
      </div>
    )
  }
}

export default connect(state => {
  return {
    user: state.user,
    session: state.botpress_session
  }
})(BotpressChat);